import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async downloadFile(context, data) {
      try {
        const config = {
          withCredentials: true,
          responseType: 'blob',
          onDownloadProgress: data.onDownloadProgress,
        };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const content = axios.get(`/autodesk/data-management/oss/buckets/${data.bucketKey}/objects/${data.objectName}`, config);
        return content;
      } catch (error) {
        throw error;
      }
    },
  },
};
